.c-multi-select {
  position: relative;
  cursor: text;
  width: 100%;
}

  .c-multi-select__list {
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    padding: var(--input-padding);
}

  .c-multi-select__list.disabled {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}

  .c-multi-select__list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  row-gap: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

  .c-multi-select__list[data-focus] {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
  --tw-ring-opacity: 0.5;
}

  .c-multi-select.invalid .c-multi-select__list {
    /* make sure this matches with the invalid styling in forms.css */
    --tw-border-opacity: 1 !important;
    border-color: rgb(248 113 113 / var(--tw-border-opacity, 1)) !important;
    --tw-text-opacity: 1 !important;
    color: rgb(127 29 29 / var(--tw-text-opacity, 1)) !important;
  }

  .c-multi-select.invalid .c-multi-select__list::placeholder {
  --tw-placeholder-opacity: 1 !important;
  color: rgb(252 165 165 / var(--tw-placeholder-opacity, 1)) !important;
}

  .c-multi-select.invalid .c-multi-select__list:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1)) !important;
  --tw-ring-opacity: 0.5 !important;
}

  .c-multi-select [data-list-entry='item'] {
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity, 1));
  overflow: hidden;
  cursor: auto;
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
  display: flex;
  align-items: center;
}

  .c-multi-select [data-list-entry='item'] span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

  .c-multi-select [data-list-entry='item'] a {
  margin-left: 0.25rem;
  flex-shrink: 0;
  pointer-events: auto;
  cursor: pointer;
}

  .c-multi-select [data-list-entry='item'] a::after {
  height: 0.75rem;
  width: 0.75rem;
  opacity: 0.5;
        /* FontAwesome xmark */
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path fill='currentColor' d='M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z'/></svg>");
        background-position: center;
        background-repeat: no-repeat;
        content: "";
        display: block;
}

  @media print {

  .c-multi-select [data-list-entry='item'] a::after {
    display: none;
  }
}

  .c-multi-select [data-list-entry='item'] a:hover::after {
  opacity: 1;
}

  .c-multi-select [data-list-entry='search'] input {
  margin: 0px;
  border-radius: 0px;
  padding: 0px;
}

  .c-multi-select [data-list-entry='search'] input, .c-multi-select [data-list-entry='search'] input:focus {
  border-width: 0px;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

  .c-multi-select__dropdown {
    background: white;
    border-radius: 0.25rem;
    box-shadow: var(--dropdown-box-shadow);
    display: none;
    margin: 2px 0 0 0;
    padding: 0;
    position: absolute;
    width: 100%;
    z-index: var(--z-index-top);
    font-size: 1rem;
    overflow: hidden;
  }

/*# sourceMappingURL=data:application/json;base64,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 */